import apiClient from "../../../shared/api/client";

import {
  type SecurityOverview,
  type SecurityRange,
  securityOverviewSchema,
} from "../types";

/**
 * The backend wraps the CrowdSec overview payload as `{ data: OVERVIEW }`
 * (mirroring the analytics endpoints), so we validate `response.data.data`.
 *
 * `range` picks the time-series window (day/week/month); it only affects the
 * charts (cards/live/lists come from the latest snapshot regardless).
 *
 * safeParse + console.error: a contract mismatch still errors the tab, but the
 * console says exactly WHICH field broke instead of a silent generic failure
 * indistinguishable from a network error.
 */

export const fetchSecurityOverview = async (
  range: SecurityRange = "day",
): Promise<SecurityOverview> => {
  const response = await apiClient.get("/admin/security/overview", {
    params: { range },
  });

  const parsed = securityOverviewSchema.safeParse(response.data.data);

  if (!parsed.success) {
    const issues = parsed.error.issues

      .map((i) => `${i.path.join(".")}: ${i.message}`)

      .join(" | ");

    console.error("[security] overview schema mismatch:", issues, {
      payload: response.data.data,
    });

    throw new Error(`Respuesta del overview inválida — ${issues}`);
  }

  return parsed.data;
};
